/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */
 
import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

// Import our default css theme for splide
import '@splidejs/splide/css';

document.addEventListener( 'DOMContentLoaded', () => {

  // Splide
  const splides = document.querySelectorAll('.splide')

  if(!!splides && splides.length > 0){
    splides.forEach(splide => {

        const sliderType = splide.dataset.sliderType;
        const pauseOnHover = splide.dataset.pauseOnHover;
        const scrollingSpeed = splide.dataset.scrollingSpeed;
        const interval = parseInt(splide.dataset.interval) * 1000 || 3000
        const gap = splide.dataset.gap + 'px';
        const perPageMobile = splide.dataset.perPageMobile;
        const perPageTablet = splide.dataset.perPageTablet;
        const perPageDesktop = splide.dataset.perPageDesktop;
        const perPageLarge = splide.dataset.perPageLarge;

        if (sliderType == 'infinite'){
            new Splide(splide, {
                type: 'loop', 
                drag: 'free',
                pagination: false, 
                lazyLoad: true,
                arrows: false,
                gap: gap,
                perPage: perPageLarge,
                breakpoints: {
                    1200: {
                        perPage: perPageDesktop
                    },
                    900: {
                        perPage: perPageTablet
                    },
                    600: {
                        perPage: perPageMobile
                    },
                },
                autoScroll: {
                    speed: scrollingSpeed,
                    pauseOnHover: pauseOnHover
                }
            }).mount( {AutoScroll} );
        }
        if (sliderType == 'carousel'){
            new Splide(splide, {
                type: 'loop', 
                drag: 'free',
                pagination: false, 
                lazyLoad: true,
                arrows: false,
                autoplay: true,
                perMove: 1,
                easing: "cubic-bezier(.57,.02,.27,1.01)",
                pauseOnHover: pauseOnHover,
                gap: gap,
                perPage: perPageLarge,
                speed: 1000,
                interval: interval,
                breakpoints: {
                    1200: {
                        perPage: perPageDesktop
                    },
                    900: {
                        perPage: perPageTablet
                    },
                    600: {
                        perPage: perPageMobile
                    },
                },

            }).mount();
        }
    })
  }
})